import React, { useState, useEffect } from 'react';
import { Collapse, Container, Navbar, NavbarToggler, NavItem } from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';
import './NavMenu.css';
import { ApiEndpoints } from '../../api/apiEndpoints';
import authService from '../api-authorization/AuthorizeService';

export function NavMenu(props) {
  const displayName = NavMenu.name;
  
  const handleMouseOver = (e, hoverImage) => {
      e.currentTarget.src = hoverImage;
    }
  
  const handleMouseOut = (e, normalImage) => {
      e.currentTarget.src = normalImage;
    }

    const [state, setState] = useState({ collapsed: true });
    const [isAdmin, setIsAdmin] = useState(false);
    const toggleNavbar = () => {
       setState({ collapsed: !state.collapsed });
    }

  const getPublicFileUrl = (fileName) => ApiEndpoints.PublicFile + "/zz_nav_" + fileName;
  
    useEffect(() => {
        authService.getUser().then(user => {
            if (user?.role?.includes('Admin')) setIsAdmin(true);
        });
    }, []);

  var location = useLocation();
  return (
      <header>
        <Navbar className="navbar-expand-md navbar-toggleable-md ng-white box-shadow mb-3" light>
          <Container>
            <Link to="/" className="navbar-brand">
                <img src={getPublicFileUrl('logo.png')} className="logo" alt="Logo" />
            </Link>
            <NavbarToggler style={{backgroundImage:`url(${getPublicFileUrl('nav-toggle.png')})`}} onClick={toggleNavbar} className="mr-2" />
            <Collapse className="d-md-inline-flex flex-md-row-reverse" isOpen={!state.collapsed} navbar>
              <ul className="navbar-nav flex-wrap">
                <NavItem>
                  <Link className="text-dark nav-link" to="/shop">
                    <span className={'link-title shop-nav-title ' + (location.pathname === '/shop' ? 'text-decoration-underline' : '')}>Shop</span>
                  </Link>
                </NavItem>
                <NavItem>
                  <Link className="text-dark nav-link" to="/illustration">
                    <span className={'link-title illustration-nav-title ' + (location.pathname === '/illustration' ? 'text-decoration-underline' : '')}>Illustration</span>
                  </Link>
                </NavItem>
                <NavItem>
                  <Link className="text-dark nav-link" to="/about">
                      <span className={'link-title about-nav-title ' + (location.pathname === '/about' ? 'text-decoration-underline' : '')}>About</span>
                  </Link>
                </NavItem>
                {
                    isAdmin &&
                        <NavItem>
                          <Link className="text-dark nav-link" to="/management/main">
                               <span className={'link-title admin-nav-title ' + (location.pathname === '/management/main' ? 'text-decoration-underline' : '')}>Admin</span>
                          </Link>
                        </NavItem>
                }
                <NavItem className="d-flex align-items-center">
                  <a className="text-dark nav-link link-title contact-nav-link" href="mailto:annanashepeta@gmail.com">
                      <span>Contact</span>
                      <img src={getPublicFileUrl('contact.png')} alt="Contact" className="img-fluid" onMouseOver={(e) => handleMouseOver(e, getPublicFileUrl('contact_selected.png'))} onMouseOut={(e) => handleMouseOut(e, getPublicFileUrl('contact.png'))} />
                  </a>
                </NavItem>
                <NavItem className="d-flex align-items-center" id="language-menu-item">
                    <div className="nav-link link-title language-nav-link d-flex align-items-center">
                     <span style={{cursor:'pointer'}} onClick={() => { 
                         document.querySelector('.gt_switcher-popup').click(); 
                         }}>
                         Site language
                     </span>
                  </div>
                </NavItem>
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
}
